import { render, staticRenderFns } from "./TheFormRestaurants2.vue?vue&type=template&id=7e104898&scoped=true&"
import script from "./TheFormRestaurants2.vue?vue&type=script&lang=ts&"
export * from "./TheFormRestaurants2.vue?vue&type=script&lang=ts&"
import style0 from "./TheFormRestaurants2.vue?vue&type=style&index=0&id=7e104898&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e104898",
  null
  
)

export default component.exports